// video-lazy.js
(function () {
  function attachSrc(v) {
    if (!v || v.dataset.attached || !v.dataset.src) return;
    const s = document.createElement('source');
    s.src = v.dataset.src;
    s.type = 'video/mp4'; // H.264 empfohlen
    v.appendChild(s);
    v.dataset.attached = '1';
    v.load();
    // Nur wenn du Autoplay willst UND muted ist:
    if (v.muted && v.autoplay) v.play().catch(() => {});
  }

  function detachSrc(v) {
    if (!v || !v.dataset.attached) return;
    v.pause();
    v.removeAttribute('src');
    v.querySelectorAll('source').forEach(n => n.remove());
    delete v.dataset.attached;
    v.load();
  }

  // Nur laden, wenn zu ~60% im Viewport
  const io = new IntersectionObserver((entries) => {
    entries.forEach(e => {
      const v = e.target;
      if (e.isIntersecting && e.intersectionRatio > 0.6) {
        attachSrc(v);
      } else {
        detachSrc(v);
      }
    });
  }, { threshold: [0, 0.6, 1] });

  function init() {
    document.querySelectorAll('video.lazy-video[data-src]').forEach(v => {
      // Sicherheits-Defaults
      v.setAttribute('preload', 'none');
      v.setAttribute('playsinline', '');
      v.setAttribute('muted', '');    // wichtig für Autoplay mobil
      // v.setAttribute('autoplay', ''); // nur setzen, wenn du Autoplay willst
      io.observe(v);
    });
  }

  // Re-init bei Ajax-Loads/Section Renders
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('DOMContentLoaded', init);
})();
